import { DatePipe,Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { serviceAppointmentTimeSlotModel,appointmentTimeSlotModel, addAppointmentRequest } from 'src/app/models/appointment/appointment';
import { appointmentReasonModel, ProviderModel } from 'src/app/models/login/login';
import { AppointmentService } from 'src/app/services/appointment.service';
declare var $:any;
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  patientpersonalinfo: any;
  selectedProvider: any;
  appointmentReasonData: any;
  curDate : any;
  minDate = new Date();
  maxDate = new Date();
  appointmentForm: FormGroup = new FormGroup({});
  currentTimeZone:any;
  appointmentSlots:any;
  selectedSlot:any;
  addAppointmentRequest: addAppointmentRequest = new addAppointmentRequest();
  isRtl: boolean = false;
  constructor(private translateService: TranslateService, private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private appoint: AppointmentService, private datepipe: DatePipe,
    private _router: Router,private location:Location) {
      let info = localStorage.getItem('PatientInfo');
      if(!info){
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
      this.selectedSlot = new serviceAppointmentTimeSlotModel();
      this.curDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.maxDate = new Date(this.maxDate.getFullYear() +1, this.maxDate.getMonth(), this.maxDate.getDate())
      this.reset();
    }
    buildappointmentForm(){
      this.appointmentForm = new FormGroup({
        appointmenttype: new FormControl('', Validators.required),
        provider: new FormControl('', Validators.required),
        reason: new FormControl('', Validators.required),
        DOappointment: new FormControl('', Validators.required)
      });
    }
    reset() {
      this.appointmentForm.reset();
      this.buildappointmentForm();
    }
    get getappointmentForm() {
      return this.appointmentForm.controls;
    }
    ngOnInit(): void {
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      this.getProviders();
      this.getAppointmentReason();
      this.getCurrentTimeZone();
      this._phrutilService.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this.isRtl = false;
          this._phrutilService.setTitle('Registro de pacientes');
        } else if (language === 'hi') {
          this.isRtl = false;
          this._phrutilService.setTitle('रोगी पंजीकरण');
        } else if (language === 'ur') {
          this.isRtl = true;
          this._phrutilService.setTitle('مریض کی رجسٹریشن');
        }
        else {
          this.isRtl = false;
          this._phrutilService.setTitle('Patient Registration');
        }
      });
    }
    providerData: any;
    getProviders() {
      
      this.spinner.show();
      //this.appoint.getProvider('1011163').subscribe((res: any) => {
      this.appoint.getProvider(this.patientpersonalinfo.practice_Code,this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data) {
          this.providerData = res.data.providers as ProviderModel[];
        }
      },
      (error: any) => {
        this.spinner.hide();
      });
    }
    getAppointmentReason() {
      this.appointmentReasonData = new Array();
      this.spinner.show();
      //this.appoint.getAppointmentReasons('1011163', '1011163565183669', '53481719', '550188').subscribe((res: any) => {
      this.appoint.getAppointmentReasons(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
        this.spinner.hide();
        if(res.data)
        {
          this.appointmentReasonData = res.data.appoitnmentReasonsLists as appointmentReasonModel[];
        }
      },
      (error:any) => {
        this.spinner.hide();
      });
    }
    onChangeDate()
    {
      if(this.appointmentForm.get('DOappointment')?.valid)
      this.appointmentForm.markAllAsTouched();
      if(!this.appointmentForm.invalid)
      {
        this.getAppointmentTimeSlot(); 
      }else
      {
        return;
      }
    }
    
    appointmentTimeSlotFlag:boolean=false;
    // getCurrentTimeZone()
    // {
    //   let dummyTimezone:any;
    //   let offset :any;
    //   let date = new Date();
    //   this.currentTimeZone = date.getTimezoneOffset().toString();
    //   if(this.currentTimeZone.length<5)
    //   {
    //     if(this.currentTimeZone.includes('-'))
    //     {
    //       dummyTimezone=this.currentTimeZone.split('-');
    //       offset = dummyTimezone[1];
    //       this.currentTimeZone='-0'+offset;
    //     }
    //     else if(this.currentTimeZone.includes('+'))
    //     {
    //       dummyTimezone=this.currentTimeZone.split('-');
    //       offset = dummyTimezone[1];
    //       this.currentTimeZone='+0'+offset;
    //     }
    //   }
    // }
    getCurrentTimeZone() {
      
      let currDate = new Date().toString();
      let getOffsetwithTime = currDate.split('(');
      let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
      this.currentTimeZone = offSet.trim();
      if(this.currentTimeZone.includes('+'))
      {
        let RemoveAlpht=this.currentTimeZone.split('+');
        this.currentTimeZone='+'+RemoveAlpht[1];
      }
      else if(this.currentTimeZone.includes('-'))
      {
        let RemoveAlpht=this.currentTimeZone.split('-');
        this.currentTimeZone='-'+RemoveAlpht[1];
      }
    }
    getAppointmentTimeSlot() {
      if(new Date(this.appointmentForm.get('DOappointment')?.value)  < new Date(this.curDate))
      {
        let text = "Previous date appointments can't be scheduled.";
        this.translateService.get('Alerts.previous_date_appointment').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
       // this._phrutilService.showInfo("Previous date appointments can't be scheduled.","");
        return;
      }
      this.spinner.show();
      let Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
      Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
      Obj_AppointmentTimeSlotModel.locationCode = this.patientpersonalinfo.location_Code;
      Obj_AppointmentTimeSlotModel.practiceCode = this.patientpersonalinfo.practice_Code;
      Obj_AppointmentTimeSlotModel.patientAccount = this.patientpersonalinfo.patient_Account;
      Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZone;
      Obj_AppointmentTimeSlotModel.isFirstAvailable = false;
      Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type =='office' ? false : true;
      Obj_AppointmentTimeSlotModel.date = this.datepipe.transform(this.appointmentForm.get('DOappointment')?.value, "MM/dd/yyyy");
      this.appoint.getAppointmentTimeSlots(Obj_AppointmentTimeSlotModel).subscribe((res:any) => {
        
        this.spinner.hide();
        if (res.statusCode == 200) {
          this.appointmentTimeSlotFlag = true;
          
          this.appointmentSlots = res.data.appointmentSlots as appointmentTimeSlotModel[];
        }  
      },
      (error:any) => {
        if (this.appointmentSlots.length > 0) {
          this.appointmentTimeSlotFlag = true;
        } else {
          this.appointmentTimeSlotFlag = false;
        }
        this.spinner.hide();
      }
      );
    }
    
    onSelectSlot(event:any,slot:any)
    {
      let i=0;
      this.appointmentSlots.map((res:any)=>{
        $('[id="slot'+i+'"]').removeClass('active');
        i++;
      }
      );
      this.selectedSlot=slot; 
      $('[id="'+event.target.id+'"]').addClass('active');
    }
    onAddScheduleAppointment() {
      
      this.appointmentForm.markAllAsTouched();
      if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
        let Obj_addScheduleAppointmentModel = new addAppointmentRequest();
        Obj_addScheduleAppointmentModel.first_Name = this.patientpersonalinfo.first_Name;
        Obj_addScheduleAppointmentModel.last_Name = this.patientpersonalinfo.last_Name;
        Obj_addScheduleAppointmentModel.dateofBrith = this.patientpersonalinfo.date_Of_Birth;
        Obj_addScheduleAppointmentModel.email = this.patientpersonalinfo.email_Address?this.patientpersonalinfo.email_Address:this.patientpersonalinfo.cell_phone;
        Obj_addScheduleAppointmentModel.phone = this.patientpersonalinfo.cell_phone;
        Obj_addScheduleAppointmentModel.app_ReasonId = this.appointmentForm.get('reason')?.value;
        Obj_addScheduleAppointmentModel.location_Code = this.patientpersonalinfo.location_Code;
        Obj_addScheduleAppointmentModel.provider_Code = this.appointmentForm.get('provider')?.value;
        Obj_addScheduleAppointmentModel.practice_code = this.patientpersonalinfo.practice_Code;
        Obj_addScheduleAppointmentModel.patient_Account = this.patientpersonalinfo.patient_Account;
        Obj_addScheduleAppointmentModel.teleMedicine_Session = this.appointment_type =='office' ? '0' : '1';
        Obj_addScheduleAppointmentModel.app_date = this.selectedSlot.availableDate;
        Obj_addScheduleAppointmentModel.client_IP = sessionStorage.getItem('IP')?sessionStorage.getItem('IP'):'';
        Obj_addScheduleAppointmentModel.patTimeZone = this.currentTimeZone;
        Obj_addScheduleAppointmentModel.time_From = this.selectedSlot.availableSlot;
        Obj_addScheduleAppointmentModel.isConsentForm = '0';
        this.spinner.show();
        this.appoint.addScheduleAppointment(Obj_addScheduleAppointmentModel).subscribe((res:any) => {
          this.spinner.hide();
          
          if (res.message.toLowerCase() == "success" && res.statusCode == 200) {
            if (res.data.isAppointmentInserted.toLowerCase() == "true") {
              let text = "Your appointment has been scheduled we need some additional details.";
              this.translateService.get('Alerts.appointment_scheduled_successfully').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
             // this._phrutilService.showSuccess("Your appointment has been scheduled we need some additional details.");
              this.patientpersonalinfo.appointmentid=res.data.appointmentId;
              let data = this._phrutilService.encrypt(this.patientpersonalinfo);
              localStorage.setItem('PatientInfo', data);
              this._router.navigateByUrl('/pay_type');
            } else {
              if (res.data.finalMessage === "You already have an appointment for this day. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_already_exist_for_the_day').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });
               
              } else if (res.data.finalMessage ==="You can make only one appointment in 14 days. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_14_day_check').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });
              }
              else {
                this._phrutilService.showInfo(res.data.finalMessage);
              }
              
            }
          } else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          }
        },
        (error:any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        });
      }
      else
      {
        if(!this.appointmentForm.invalid && !this.selectedSlot.availableSlot && !this.selectedSlot.availableDate)
        {
          let text = "Please select appointment slot first.";
          this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
         // this._phrutilService.showInfo("Please select appointment slot first.");
        }
        return;
      }
    }
    backPage()
    {
      this._router.navigateByUrl("/home?practice_code="+this.patientpersonalinfo.practice_Code);
    }
    appointment_type:any;
    selectAppointmenttype(type:any)
    {
      if(type=='office')
      {
        this.appointment_type='office';
        this.onChangeDate();
      }
      if(type=='telehealth')
      {
        this.appointment_type='telehealth';
        this.onChangeDate();
      }
    }

  focusOutFunction(e: any, type: any){
    //console.log(this.getappointmentForm.DOappointment);
    if (this.appointmentForm.get('DOappointment')?.valid) {
      let date =  this.getappointmentForm.DOappointment.value.split('-');
      if(Number(date[0]) < this.minDate.getFullYear()){
        this.getappointmentForm.DOappointment.setValue(this.minDate.getFullYear()+'-'+date[1]+'-'+date[2]);
      }
      if(Number(date[0]) > this.maxDate.getFullYear()){
        this.getappointmentForm.DOappointment.setValue(this.minDate.getFullYear()+'-'+date[1]+'-'+date[2]);
      }
    }
  }
  }
